<template>
  <div v-loading="loading">
    <el-form :model="form" :rules="rules" ref="form" label-width="150px">
      <el-form-item label-width="0">
        <ul class="ul flex">
          <li class="li-active">1.企业信息</li>
          <li class="li-active-r"></li>
          <li class="li-active-l"></li>
          <li class="li-active">2.品牌与资质信息</li>
          <li class="li-active-r"></li>
          <li class="li-l"></li>
          <li class="li">3.供应商信息</li>
          <li class="li-r"></li>
        </ul>
      </el-form-item>
      <el-form-item label-width="0">
        <div class="title">
          <p></p>
          <p>纸质营业执照</p>
        </div>
      </el-form-item>
      <!-- <el-form-item label="营业执照图片上传" prop="businessLicensePic">
        <div class="flex flex-end">
          <el-upload action="#" :auto-upload="false" :show-file-list="false" class="uploader"
            :on-change="value => handleChange(value, 'businessLicensePic')">
            <img v-if="form.businessLicensePic" :src="form.businessLicensePic">
            <i v-else class="el-icon-plus"></i>
          </el-upload>
          <el-button type="text" class="mgl10"
            @click="handlePreview('https://ksaximg.ksaxshop.com/register/%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%E7%A4%BA%E5%9B%BE.png')">查看示例</el-button>
        </div>
        <p class="msg">图片尺寸请确保800px*800px以上，大小在10MB以内，支持png、jpg、jpeg、gif格式</p>
        <p class="msg">请上传清晰营业执照图片，系统识别公司信息自动进行填写，营业执照复印件需加盖公司红章扫描上传</p>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName"></el-input>
            <p class="msg">请按照营业执照登记的完整名称填写，如有（）请在输入法为中文下输入</p>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="主营类目" prop="typeIds">
            <el-select class="w100" v-model="form.typeIds" multiple placeholder="请选择">
              <el-option v-for="item in typeData" :key="item.id" :label="item.typeName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="品牌" prop="brands">
            <el-select class="w100" v-model="form.brands" multiple placeholder="请选择" filterable remote
              :remote-method="getBrandList" @change="handleBrand">
              <el-option v-for="item in brandData" :key="item.id" :label="item.brandName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0">
        <ul class="flex flex-wp">
          <li v-for="(item, index) in form.supplierSettledBrands" :key="index" class="mgl10 mgt10"
            @click="brandActive = parseInt(item.brandId)">
            <el-tag :effect="brandActive === parseInt(item.brandId) ? 'dark' : 'plain'" style="cursor: pointer;">
              {{ item.brandName }}
            </el-tag>
          </li>
        </ul>
        <p class="msg">*点击切换品牌，填写《品牌与资质信息》</p>
      </el-form-item>
      <el-card shadow="never" v-for="(item, index) in form.supplierSettledBrands" :key="index"
        v-if="brandActive === parseInt(item.brandId)">
        <div slot="header">
          <span>销售授权书</span>
        </div>
        <el-form-item label-width="0">
          <p class="msg">1、以商标持有人为源头出发的，授权至开店公司的完整授权链条</p>
          <p class="msg">2、商标持有人是开店公司/法人，无需提交授权书</p>
          <p class="msg">3、所有授权都要加盖授权方及开店公司红章</p>
        </el-form-item>
        <el-form-item label="是否品牌商" :prop="`supplierSettledBrands[${index}].isBrandDealer`"
          :rules="{ required: true, message: '请选择', trigger: 'change' }">
          <el-radio-group v-model="item.isBrandDealer">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <p class="msg">是：商标持有人是开店公司/法人</p>
        </el-form-item>
        <el-form-item label="销售授权书">
          <el-upload action="#" :auto-upload="false" :show-file-list="false" class="uploader"
            :on-change="value => handleChange(value, index, 'attorneyPic')">
            <img v-if="item.attorneyPic" :src="item.attorneyPic">
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-card>
      <div class="textC mgt20">
        <el-button @click="$router.go(-1)">上一步</el-button>
        <el-button type="primary" @click="handleNext">下一步</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  getQiniuToken,
} from "../../api/api";

export default {
  components: {},
  data() {
    return {
      loading: false,
      form: {
        typeIds: []
      },
      rules: {
        typeIds: [{ required: true, message: '请选择', trigger: 'change' }],
        brands: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      qiniuToken: "",
      typeData: [],
      brandData: [],
      brandActive: 0
    };
  },
  created() {
    this.getQiniuToken()
    this.getDetail()
    this.getTypeTreeList()
    this.getBrandList()
  },
  mounted() {

  },
  methods: {
    getDetail() {
      let data = {
        path: "Business_SupplierSettled/AddSupplierSettled",
        parms: "",
        parmsJson: {
          contactPhone: this.$route.query.phone,
          step: 0,
        }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          const { typeIds, supplierSettledBrands } = res.data.response
          res.data.response.typeIds = typeIds ? typeIds.split(",").map(item => {
            return parseFloat(item)
          }) : []
          res.data.response.supplierSettledBrands = supplierSettledBrands || []
          res.data.response.brands = res.data.response.supplierSettledBrands.map(item => {
            return parseInt(item.brandId)
          }) || []
          if (res.data.response.brands.length) {
            this.brandActive = res.data.response.brands[0]
          }
          this.form = res.data.response
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getQiniuToken() {
      getQiniuToken().then((res) => {
        this.qiniuToken = res.data;
      }).catch(() => { });
    },
    handleChange(file, index, type) {
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: this.qiniuToken,
      };
      this.$utils.uploadImgToQiniu(file.raw, qiniuData).then((res) => {
        this.form.supplierSettledBrands[index][type] = res
      }).catch((err) => {
        this.$message.error(err);
      });
    },
    handleNext() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let data = {
            path: "Business_SupplierSettled/AddSupplierSettled",
            parms: "",
            parmsJson: {
              ... this.form,
              step: 2,
              typeIds: this.form.typeIds.join(),
              typeNames: this.form.typeIds.map(item => {
                return this.typeData.filter(a => a.id === item)[0].typeName
              }).join(),
              typeInfoList: this.form.typeIds.map(item => {
                return {
                  typeIds: item,
                  typeNames: this.typeData.filter(a => a.id === item)[0].typeName
                }
              })
            }
          }
          this.loading = true
          KSAXApiRequest(data).then(res => {
            this.loading = false
            if (res.data.success) {
              this.$router.push(`/SupEnter/Step3?phone=${this.$route.query.phone}`)
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      });
    },
    getTypeTreeList() {
      let data = {
        path: "Product_Type/TreeList",
        parms: "",
        parmsJson: null
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.typeData = res.data.response
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getBrandList(e) {
      let data = {
        path: "Product_Brand/list",
        parms: "",
        parmsJson: {
          pageIndex: 1,
          pageSize: 100,
          brandName: e ? e : ""
        }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.brandData = res.data.response.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleBrand() {
      let supplierSettledBrands_ = []
      this.form.brands.forEach((a, ai) => {
        const check = this.form.supplierSettledBrands.filter(item => parseInt(item.brandId) === a)
        if (check.length) {
          supplierSettledBrands_.push(check[0])
        } else {
          supplierSettledBrands_.push({
            brandId: a,
            brandName: this.brandData.filter(item => item.id === a)[0].brandName,
            isBrandDealer: false,
            attorneyPic: "",
          })
        }
      });
      this.form.supplierSettledBrands = supplierSettledBrands_
    }
  },
};
</script>

<style scoped>
.ul li {
  padding: 0 30px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.li-active {
  background: #3B6FFA;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 14px;
  color: #FFFFFF;
}

.li-active-r {
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid #3B6FFA;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.li {
  background: #EBF2FA;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.li-r {
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid #EBF2FA;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.li-l {
  margin-left: -5px;
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid transparent;
  border-top: 18px solid #EBF2FA;
  border-bottom: 18px solid #EBF2FA;
}

.li-active-l {
  margin-left: -5px;
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid transparent;
  border-top: 18px solid #3B6FFA;
  border-bottom: 18px solid #3B6FFA;
}

.title {
  background: #ecf5ff;
  display: flex;
  align-items: center;
}

.title p:first-child {
  height: 40px;
  width: 4px;
  background-color: #3B6FFA;
}

.title p:last-child {
  margin-left: 10px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.msg {
  line-height: 2;
  color: rgb(0 0 0 / 50%);
}

.uploader>>>.el-upload {
  width: 120px;
  height: 120px;
  border: 1px dashed #8c939d;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uploader img {
  max-width: 100%;
  max-height: 100%;
}
</style>
